export default "__VITE_ASSET__GYo45TLs__"